module.exports = __webpack_public_path__ + "img/600x300-light.569e11b0.png";